export const API_BASE_URL = process.env.REACT_APP_SERVER_URL;
export const API_STORAGE_BASE_URL =
  process.env.REACT_APP_SERVER_STORAGE_URL || `${API_BASE_URL}/storage`;
export const API_DEFAULT_LANGUAGE = process.env.REACT_APP_DEFAULT_LANGUAGE;
export const ACCESS_TOKEN_NAME = 'login_access_token';
export const ACCESS_USER_DATA = 'login_user_data';
export const API_PUSHER_KEY = process.env.REACT_APP_PUSHER_KEY;
export const API_PUSHER_CLUSTER = process.env.REACT_APP_PUSHER_CLUSTER;
export const APP_DOMAIN_ADMIN = process.env.REACT_APP_DOMAIN_ADMIN;
export const APP_RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
